export function continueGoogleDataOAuth({
    authorizationUrl,
    projectId,
    integrationId = null,
    resetCurrentUserProjects,
    browserWindow = window,
}) {
    browserWindow.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            browserWindow.location.reload();
        }
    }, {once: true});
    resetCurrentUserProjects();
    browserWindow.history.replaceState(
        browserWindow.history.state,
        '',
        integrationId === null
            ? `/project/${projectId}/settings/integrations/create`
            : `/project/${projectId}/settings/integrations?integrationId=${integrationId}`,
    );
    browserWindow.location.assign(authorizationUrl);
}
